const US_PRICING_QUERY_KEY = '__mk';
const US_PRICING_QUERY_VALUE = '17';
const US_COUNTRY_CODE = 'US';

export function useUSPricing() {
  const route = useRoute();
  const userCountry = useCookie('user-country');
  const isUSUser = computed(() => {
    return userCountry.value === US_COUNTRY_CODE;
  });

  const isUSPricing = computed(() => {
    const queryValue = route.query[US_PRICING_QUERY_KEY];
    const isQueryOverride = queryValue === US_PRICING_QUERY_VALUE;

    return isQueryOverride || isUSUser.value;
  });

  return {
    isUSPricing,
  };
}
